import {
  ConversationsV2ChatState,
  ObservationsV1IssueStatus,
} from '@spotify/confidence-graphql';

type IssueDriver = {
  __typename?: string;
  name?: string;
  state?: ConversationsV2ChatState | null;
} | null;

export const getIssueDriverChatName = (issue: {
  driver?: IssueDriver;
}): string | undefined => {
  if (
    !issue.driver ||
    issue.driver.__typename === 'Error' ||
    !issue.driver.name
  ) {
    return undefined;
  }

  return issue.driver.name;
};

const isIssueDriverRunning = (issue: { driver?: IssueDriver }): boolean =>
  !!getIssueDriverChatName(issue) &&
  issue.driver?.state === ConversationsV2ChatState.Running;

export const isIssueAgentRunning = (issue: {
  driver?: IssueDriver;
  status?: ObservationsV1IssueStatus | null;
}): boolean =>
  isIssueDriverRunning(issue) ||
  issue.status === ObservationsV1IssueStatus.Running;
